export const hasToRenderGiftHat = (t, market) => {
  const bundleLabel = t('ficha.producto', `bundle.text.${market}`) !== undefined && t('ficha.producto', `bundle.text.${market}`) !== null;
  const bundleLabelHasValue = bundleLabel && bundleLabel !== `ficha.producto.bundle.text.${market}` && bundleLabel.length > 1;
  return bundleLabelHasValue;
};
